/**
 * GraphViewerAdapter
 *
 * Thin adapter wiring GraphViewer into the component registry.
 * Mirrors WetlabWorkflowAdapter and RunInfoAdapter.
 */

import React from 'react';
import { GraphViewer } from './GraphViewer';

export const GraphViewerAdapter: React.FC = () => {
  return <GraphViewer />;
};
